module.exports = __webpack_public_path__ + "img/feature2@2x.efd1846.png";